var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import BaseMessage from './BaseMessage';
import { cliAnalyticsError, cliAnalyticsRequestApproval, cliAnalyticsRequestDecline, cliAnalyticsRequestPartialApproval } from '../../../../const/analytics';
import { ConfigContext } from '../../context';
import { translate } from '../../../../strings/i18n';
export var Success = function (_a) {
    var newCreditLimit = _a.newCreditLimit, image = _a.image;
    var triggerAnalyticsEvent = useContext(ConfigContext).triggerAnalyticsEvent;
    useEffect(function () {
        triggerAnalyticsEvent(cliAnalyticsRequestApproval);
    });
    return (_jsx(BaseMessage, __assign({}, {
        id: 'cli-full-approval',
        newCreditLimit: newCreditLimit,
        image: image,
        title: translate('cliSuccess.title'),
        subTitle: translate('cliSuccess.subTitle'),
        subText: translate('cliSuccess.subText')
    })));
};
export var PartialSuccess = function (_a) {
    var newCreditLimit = _a.newCreditLimit, image = _a.image;
    var triggerAnalyticsEvent = useContext(ConfigContext).triggerAnalyticsEvent;
    useEffect(function () {
        triggerAnalyticsEvent(cliAnalyticsRequestPartialApproval);
    });
    return (_jsx(BaseMessage, __assign({}, {
        id: 'cli-partial-success',
        newCreditLimit: newCreditLimit,
        image: image,
        title: translate('cliSuccess.title'),
        subTitle: translate('cliPartialSuccess.subTitle'),
        subText: translate('cliSuccess.subText')
    })));
};
export var ErrorMessage = function (_a) {
    var id = _a.id, image = _a.image;
    var triggerAnalyticsEvent = useContext(ConfigContext).triggerAnalyticsEvent;
    useEffect(function () {
        triggerAnalyticsEvent(cliAnalyticsError);
    });
    return (_jsx(BaseMessage, __assign({}, {
        id: id,
        image: image,
        subTitle: translate('errorMessages.unableToProcessRequest')
    })));
};
export var BusinessErrorMessage = function (_a) {
    var creditLimit = _a.creditLimit, errorMessage = _a.errorMessage;
    var triggerAnalyticsEvent = useContext(ConfigContext).triggerAnalyticsEvent;
    useEffect(function () {
        triggerAnalyticsEvent(__assign(__assign({}, cliAnalyticsRequestDecline), { message: errorMessage }));
    });
    return (_jsx(BaseMessage, __assign({}, {
        id: 'cli-business-error',
        title: translate('cliBusinessError.title'),
        subTitle: translate('cliBusinessError.subTitle'),
        currentCreditLimit: creditLimit
    })));
};
export var PendingReferral = function (_a) {
    var creditLimit = _a.creditLimit, errorMessage = _a.errorMessage;
    var triggerAnalyticsEvent = useContext(ConfigContext).triggerAnalyticsEvent;
    useEffect(function () {
        triggerAnalyticsEvent(__assign(__assign({}, cliAnalyticsRequestDecline), { message: errorMessage }));
    });
    return (_jsx(BaseMessage, __assign({}, {
        id: 'cli-pending-referral',
        title: translate('cliPendingReferral.title'),
        subTitle: translate('cliPendingReferral.subTitle'),
        currentCreditLimit: creditLimit
    })));
};
